import React from 'react'
import { Button, Container, Row, Col } from 'react-bootstrap';
import Meta from '../../components/Meta';
import { LinkContainer } from 'react-router-bootstrap';
import { SUPPORT_EMAIL } from '../../constants/constants';

const Guide = () => {
  return (
    <>
    <Meta
      title='サービスのご案内 | ふるぷら'
      description='ふるぷらのサービスのご案内についてのページです。'
      keywords={['ふるぷら', '古着', 'ヘルプ']}
    />
    <Container className='my-5'>
      <Row className='justify-content-center'>
        <Col xs={12} md={8} lg={5}>
          <section className='guidetop1'>
            <h1 className="fs-3 mb-4 text-center"> サービスのご案内</h1>
          </section>        
          <section className='guidetop2'>
            <h1 className="fs-5 mb-4 text-center">ふるぷらとは？</h1>
              <p>
              ふるぷらは、古着好きやもっと気軽に古着を楽しみたい方、衣装として古着を着たい方におすすめのECサイトです。

              さまざまな古着屋さんのアイテムを、レンタルサブスクリプション・単発レンタル・購入から選んでご利用いただけます。

              お店で気に入った服をそのままレンタルして持ち帰ることも、おうちで好きな古着を探して郵送で受け取ることも可能。

              クリーニング不要で、気軽にご利用いただけます。
              </p>
          <br />
          </section>
          <section className='guidetop3'>
            <h1 className="fs-5 fw-bold mb-4 text-center text-info">何かお困りごとはありますか？</h1>
            <div className='help-categories'>
                <div className='guidebutton-button'>
                <a
                  href="https://about.furupura.jp/lp/general/shimokitaall/1/index.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                    <h1 className="fs-6 fw-bold mb-4 text-center">はじめての方へ</h1>
                    <p className='guidebutton-p'>ふるぷらの特徴について、詳しく説明いたします。</p>
                  </a>
                </div> 
                <div className='guidebutton-button'>
                  <LinkContainer to='/help/guide/howtorental'>
                    <div>
                      <h1 className="fs-6 fw-bold mb-4 text-left">購入・レンタル方法について</h1>
                        <ul className='guidebutton-p'>
                          <li>・購入手順(通常購入・レンタル中の購入)</li>
                          <li>・レンタル手順(遅延・延長の仕方)</li>
                          <li>・レンタル開始日と返却予定日について</li>
                        </ul>
                    </div> 
                   </LinkContainer>
                 </div>
                 <div className='guidebutton-button'>
                    <LinkContainer to='/help/guide/priceguide'>
                      <div>
                        <h1 className="fs-6 fw-bold mb-4 text-left">料金・支払方法について</h1>
                          <ul className='guidebutton-p'>
                            <li>・購入・レンタルの価格</li>購入・レンタルの価格<br />
                            <li>・支払方法</li>
                            <li>・遅延・破損・紛失した場合の追加料金</li>
                          </ul>
                      </div>
                    </LinkContainer>
                </div>
                <div className='guidebutton-button'>
                  <LinkContainer to='/help/guide/catchreturn'>
                    <div>
                      <h1 className="fs-6 fw-bold mb-4 text-left">配送・受取・返却について</h1>
                        <ul className='guidebutton-p'>
                          <li>・配送方法・送料</li>
                          <li>・納期</li>
                          <li>・返却方法(返却期限・送料)</li>
                        </ul>
                    </div>
                  </LinkContainer>
                </div>
                <div className='guidebutton-button'>
                  <LinkContainer to='/help/cancellation-return-policy'>
                    <div>
                      <h1 className="fs-6 fw-bold mb-4 text-left">キャンセル・返品について</h1>
                        <ul className='guidebutton-p'>
                            <li>・購入・単発レンタル手続き後のキャンセル・変更</li>
                            <li>・返品・返金</li>
                        </ul>
                    </div>
                  </LinkContainer>
                </div>
                <div className='guidebutton-button'>
                  <LinkContainer to='/help/guide/accountguide'>
                    <div>
                      <h1 className="fs-6 fw-bold mb-4 text-center">アカウントについて</h1>
                        <ul className='guidebutton-p'>
                          <li>・会員登録方法</li>
                          <li>・パスワード再設定方法</li>
                          <li>・解約方法</li>
                        </ul>
                    </div>
                  </LinkContainer>
                </div>
                <div className='guidebutton-button'>
                  <LinkContainer to='/help/guide/coupon'>
                    <div>
                      <h1 className="fs-6 fw-bold mb-4 text-center">クーポン</h1>
                        <ul className='guidebutton-p'>
                          ・クーポンの利用方法<br />
                        </ul>
                    </div>
                  </LinkContainer>
                </div>
                <div className='guidebutton-button'>
                  <LinkContainer to='/help/guide/howtoguide'>
                    <div>
                      <h1 className="fs-6 fw-bold mb-4 text-center">サイトガイド</h1>
                        <ul className='guidebutton-p'>
                          <li>・プロフィールページの使い方</li>
                          <li>・お気に入り機能について</li>
                          <li>・レンタル履歴・購入履歴の確認方法</li>
                        </ul>
                    </div>
                  </LinkContainer>
                </div>
                <div className='guidebutton-button'>
                  <LinkContainer to='/help/guide/faq'>
                    <div>
                      <h1 className="fs-6 fw-bold mb-4 text-center">よくある質問</h1>
                      <p className='guidebutton-p'>
                        お客様の疑問点にお応えします。<br />
                      </p>
                    </div>
                  </LinkContainer>
                </div>
              </div>
              <br />
              <div className='supportcenter'>
                <h2 className="fs-5 fw-bold mb-4 text-center">お問い合わせ</h2>
                <p>
                  上記ヘルプページでもお客様の疑問点が解消されなかった場合は、<br />
                  <a
                    href={`mailto:${SUPPORT_EMAIL}`}
                    style={{ marginLeft: '0.5rem', color: '#0070f3' }}
                >
                    {SUPPORT_EMAIL}
                  </a>
                  にお問い合わせください。<br />
                  ※365日24時間対応しております。<br />
                  <br />
                  公式LINEには、<br />
                  ・ECサイト<br />
                  ・加盟店マップ<br />
                  ・サービス詳細<br />
                  ・お問い合わせ<br />
                  ・各加盟店の新着商品の情報<br />
                  に即アクセスできる機能がついています。<br />
                  <br />
                  こちらより、公式LINEの登録ができます！<br />
                </p>
                <Button
                  as="a"
                  href="https://line.me/R/ti/p/@145kbhwj"
                  target="_blank"
                  rel="noopener noreferrer"
                  variant='success'
                >
                    公式LINE
                </Button>
              </div>   
          </section>
        </Col>
      </Row>
    </Container>
    </>  
  )
}

export default Guide